var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/SpacingExtension.ts
import "@adornis/buildify/client/components/x-buildify-color-picker.js";
import "@adornis/buildify/client/components/x-buildify-spacing-picker.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/forms/x-checkbox.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseSpacing } from "../../db/extensions/BaseSpacing.js";
import "../components/x-buildify-color-picker.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var SpacingExtension = {
  class: BaseSpacing,
  toolbar: { icon: "space_bar", text: { default: "Abstand" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-spacing-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-spacing-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="md">
        <x-buildify-spacing-picker
          select
          placeholder="Abstand"
          select
          ${contentController.field(...controllerBaseKeyPath, "distance")}
        ></x-buildify-spacing-picker>
        <x-checkbox
          label="Linie anzeigen?"
          ${contentController.field(...controllerBaseKeyPath, "hasDividingLine")}
          @value-picked=${() => host.requestUpdate()}
        ></x-checkbox>
        ${content.hasDividingLine ? html`
              <x-buildify-color-picker
                placeholder="Linienfarbe"
                ${contentController.field(...controllerBaseKeyPath, "dividingLineColor")}
              ></x-buildify-color-picker>
              <x-buildify-spacing-picker
                placeholder="Liniendicke"
                ${contentController.field(...controllerBaseKeyPath, "dividingLineSize")}
              ></x-buildify-spacing-picker>
            ` : nothing}
      </x-flex>
    `;
  },
  group: "Layout"
};
var XSpacingExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return html`
      <x-flex
        ${css({
      background: this._consumedMode.value === "edit" ? this.colors.accent.shade(200) : "",
      minHeight: this.defaultValue("distance", { global: "10px" }),
      minWidth: "100%"
    })}
        center
        w100
        h100
      >
        ${content.hasDividingLine ? html`
              <x-flex
                ${css({
      background: this.defaultValue("dividingLineColor", { global: "#333" }),
      height: this.defaultValue("dividingLineSize", { global: "3px" })
    })}
              ></x-flex>
            ` : nothing}
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: "100%"
        }
      }
    ];
  }
};
XSpacingExtension = __decorateClass([
  customElement("x-spacing-extension")
], XSpacingExtension);
export {
  SpacingExtension,
  XSpacingExtension
};
